import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

interface OpenGraphTagsProps {
  title: string;
  description: string;
  url: string;
  imageUrl?: string;
  type?: string;
  siteName?: string;
}

const OpenGraphTags: React.FC<OpenGraphTagsProps> = ({
  title,
  description,
  url,
  imageUrl,
  type = 'website',
  siteName = 'LearnHub',
}) => {
  // Create a full image URL if it's a relative path
  const fullImageUrl = imageUrl && !imageUrl.startsWith('http') 
    ? `${window.location.origin}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}` 
    : imageUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={siteName} />
      {fullImageUrl && <meta property="og:image" content={fullImageUrl} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {fullImageUrl && <meta name="twitter:image" content={fullImageUrl} />}
    </Helmet>
  );
};

export default OpenGraphTags;
